/** @format */
import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum CardVariant {
    CHILD_SUBTLE = 'child-subtle',
    DEFAULT = 'default',
}

export const StyledCard = styled.div<{ $variant: CardVariant }>`
    ${({ $variant }) => {
        switch ($variant) {
            case CardVariant.CHILD_SUBTLE:
                /* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
                return css`
                    ${theme.typography.body_normal_highlight}
                    background-color: var(--colors-surface-secondary);
                    border-radius: var(--layout-spacing-4);
                    padding: 0 var(--layout-spacing-12);
                `;
            /* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
            case CardVariant.DEFAULT:
            default:
                return `
                    padding: var(--layout-spacing-24);
                    background-color: var(--colors-surface-primary);
                    border-radius: 0.8rem;
                    box-shadow: var(--effects-shadow-base);
                `;
        }
    }}
`;

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type CardProps = PropsWithChildren<{
    variant?: CardVariant;
    'data-testid'?: string;
    className?: string;
}>;

export const Card = ({
    variant = CardVariant.DEFAULT,
    'data-testid': dataTestid,
    children,
    ...otherProps
}: CardProps) => {
    return (
        // eslint-disable-next-line @mpb-com/mpb/transient-props-last -- Legacy code: do not use as an example.
        <StyledCard $variant={variant} data-testid={dataTestid} {...otherProps}>
            {children}
        </StyledCard>
    );
};
